import { isEmpty } from 'radash';
export const getLinkoutPrefixHttps = (linkout: string): string => {
  if (isEmpty(linkout)) return '';
  linkout = linkout.trim();
  const regEx = /^(http|https):\/\//;
  const isHasHttps = linkout.match(regEx);
  if (isHasHttps) return linkout;
  return `https://${linkout}`;
};